'use client'

import { cn } from '@/utilities/ui'
import * as LabelPrimitive from '@radix-ui/react-label'
import { type VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'

// Wilson form field label — Figma Field spec (label nodes 2198:38544 / 2198:38561 /
// 2198:38541, Body/bodyXs): Lato Light (300), font/size/xs 12 / font/lineHeight/xs 14
// (the `text-body-xs` token), UPPERCASE, color theme/foreground (#000), letter-spacing 0.
// Rendered as a block so it stacks above the input.
// `!` important modifiers defeat the unlayered `article form label` override in globals.css.
// Checkbox / radio option labels override these via className (14px / regular / none).
const labelVariants = cva(
  'block !font-light !text-body-xs !uppercase !tracking-normal text-black peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
)

const Label: React.FC<
  { ref?: React.Ref<HTMLLabelElement> } & React.ComponentProps<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
> = ({ className, ref, ...props }) => (
  <LabelPrimitive.Root className={cn(labelVariants(), className)} ref={ref} {...props} />
)

export { Label }
